import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import { Tooltip } from '@material-ui/core';
import TablePagination from '@material-ui/core/TablePagination';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
  table: {
    minWidth: '90%',
  },
  rootTable: {
    minWidth: '90%',
    background: '#FFFFFF',
    boxShadow: '-1px 0px 20px 1px rgba(0, 0, 0, 0.1)',
    borderRadius: '20px',
    width: '100%',
    marginTop: '0.5%',
    padding: '15px',
  },
  delete: {
    color: '#ff0011',
  },
  button1: {
    width: 20,
    height: 20,
    padding: 0,
  },
  button2: {
    width: 40,
    height: 20,
    padding: 0,
  },
  icon: {
    width: 64,
    height: 64,
  },
  MuiTableRowroot: {
    fontWeight: 'bold !important',
    fontSize: '17px !important',
  },
  btn: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '20%',
    background: '#E92141',
    margin: `1.5% 0`,

    '&:hover': {
      backgroundColor: '#E92141',
    },
  },
});

function TableComponent({ data, HandleDelete, updateUrl }) {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Grid
      style={{
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <Grid
        spacing={1}
        container
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Grid item lg={3} xs={12} md={4} sm={12}></Grid>
      </Grid>
      <br />
      <TableContainer className={classes.rootTable}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                className={classes.MuiTableRowroot}
                style={{ borderBottom: '2px solid gray' }}
              >
                Name
              </TableCell>
              <TableCell
                className={classes.MuiTableRowroot}
                style={{ borderBottom: '2px solid gray' }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.id}>
                  <TableCell
                    component="th"
                    scope="row"
                    style={{ borderBottom: 'none' }}
                  >
                    {row.label}
                  </TableCell>
                  <TableCell style={{ borderBottom: 'none' }}>
                    <div style={{ display: 'flex', justifyContent: 'start' }}>
                      <Tooltip title="Update">
                        <IconButton
                          className={classes.button1}
                          component={Link}
                          to={`/${updateUrl}/${row.id}`}
                        >
                          <img
                            src="/edit.svg"
                            alt="edit-img"
                            style={{ width: '22px' }}
                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          className={classes.button2}
                          onClick={() => HandleDelete(row.id)}
                        >
                          <img
                            src="/delete.svg"
                            style={{ width: '19px' }}
                            alt=""
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data?.length || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage} // Ensure this prop is named correctly
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Grid>
  );
}

export default TableComponent;